import React from "react";
import { Link } from 'react-router-dom';

function Next({ url=null }){
    return (
        <Link to={url} className="circle next-previous" style={{fontSize: '1rem'}}>Next</Link>
    );
}

export default Next;